import React from "react";

export default function AFSOrder() {
    return (
        <>
        </>
    )
}